import { Tag } from "antd";
import { TextService } from "../../Services/TextService";

export enum EventListStatus {
    Open = 0,
    ClosedForReplies = 1,
    Finished = 2
}

/**
 * The status shown for an event, the same on /myevents and on Status & Svar. Finished when every time has
 * ended. Closed for replies when the admin closed it (state 1) or the deadline has passed. Otherwise open.
 */
export const getEventListStatus = (event: { state?: number | null, deadline?: string | Date | null, times?: { end?: string | Date | null }[] | null }) => {
    const now = new Date();
    const ends = (event.times ?? []).filter(time => time.end).map(time => new Date(time.end!).getTime());

    if (ends.length > 0 && Math.max(...ends) < now.getTime()) {
        return EventListStatus.Finished;
    }

    if (event.state === 1 || (event.deadline && new Date(event.deadline) < now)) {
        return EventListStatus.ClosedForReplies;
    }

    return EventListStatus.Open;
};

// The same height as tags with an icon of their own, like the event type next to it.
export const eventTagStyle = { display: "inline-flex", alignItems: "center", lineHeight: "20px" };

/**
 * Only shows the status. Closing and opening the event is done with the button on Status & Svar (EventStateButton).
 */
export const EventStatusTag = (props: { status: EventListStatus }) => {
    const GetText = TextService.GetText;

    switch (props.status) {
        case EventListStatus.Finished:
            // A grey tag of its own; the default tag looks black next to the coloured ones.
            return <Tag style={{ ...eventTagStyle, color: "#8c8c8c", background: "#f5f5f5", borderColor: "#d9d9d9" }}>{GetText("MyEvents_StatusFinished")}</Tag>;
        case EventListStatus.ClosedForReplies:
            return <Tag color="orange" style={eventTagStyle}>{GetText("MyEvents_StatusClosed")}</Tag>;
        default:
            return <Tag color="green" style={eventTagStyle}>{GetText("MyEvents_StatusOpen")}</Tag>;
    }
};
